/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationsListUsers } from "../funcs/organizationsListUsers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListUsersResult } from "../models/components/listusersresult.js";
import {
  ListOrganizationUsersRequest,
  ListOrganizationUsersSecurity,
} from "../models/operations/listorganizationusers.js";
import { unwrapAsync } from "../types/fp.js";
export type ListOrganizationUsersQueryData = ListUsersResult;

export function prefetchListOrganizationUsers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListOrganizationUsersRequest | undefined,
  security?: ListOrganizationUsersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListOrganizationUsersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListOrganizationUsersQuery(
  client$: GramCore,
  request?: ListOrganizationUsersRequest | undefined,
  security?: ListOrganizationUsersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListOrganizationUsersQueryData>;
} {
  return {
    queryKey: queryKeyListOrganizationUsers({
      gramSession: request?.gramSession,
    }),
    queryFn: async function listOrganizationUsersQueryFn(
      ctx,
    ): Promise<ListOrganizationUsersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationsListUsers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListOrganizationUsers(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "organizations", "listUsers", parameters];
}
